export const questionConstants = {
  GETALL_REQUEST: 'QUESTIONS_GETALL_REQUEST',
  GETALL_SUCCESS: 'QUESTIONS_GETALL_SUCCESS',
  GETALL_FAILURE: 'QUESTIONS_GETALL_FAILURE',

  CREATE_REQUEST: 'QUESTION_CREATE_REQUEST',
  CREATE_SUCCESS: 'QUESTION_CREATE_SUCCESS',
  CREATE_FAILURE: 'QUESTION_CREATE_FAILURE',

  UPDATE_REQUEST: 'QUESTION_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'QUESTION_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'QUESTION_UPDATE_FAILURE',

  DELETE_REQUEST: 'QUESTION_DELETE_REQUEST',
  DELETE_SUCCESS: 'QUESTION_DELETE_SUCCESS',
  DELETE_FAILURE: 'QUESTION_DELETE_FAILURE',

  DELETE_MULTIPLE_REQUEST: 'QUESTION_DELETE_MULTIPLE_REQUEST',
  DELETE_MULTIPLE_SUCCESS: 'QUESTION_DELETE_MULTIPLE_SUCCESS',
  DELETE_MULTIPLE_FAILURE: 'QUESTION_DELETE_MULTIPLE_FAILURE',
};
